import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ManualArea } from '@thive/fddm-types';
import { Stack } from '@mui/system';

import { Accordion } from '@common/components/Accordion';
import { VehicleType } from '@/modules/salesWorkspace/components/propertyPanel/layout/components/common/VehicleType';

import { LoadType } from '../singularStation/LoadType';
import { LoadHandlingType } from './LoadHandlingType';
import { StationSpecProperties } from './StationSpecProperties';
import { UserPreferenceName } from '@/modules/userPreferences';
import {
  FIELDS_PADDING_BOTTOM,
  FIELDS_SPACING,
  PANEL_ACCORDION_SX,
} from '@/modules/common/constants/propertyPanel';

interface Props {
  selectedManualAreas: ManualArea[];
}

function ManualAreaParametersComponent({ selectedManualAreas }: Props) {
  const { t } = useTranslation();
  const title =
    selectedManualAreas.length === 1
      ? t<string>('interface:properties.manual_area.title', 'Manual Area')
      : t<string>(
          'interface:properties.manual_area.title_plural',
          `Manual Areas (${selectedManualAreas.length})`,
          { amount: selectedManualAreas.length },
        );

  return (
    <Accordion
      persistId={UserPreferenceName.ACCORDION_PROPERTY_PANEL_MANUAL}
      title={title}
      unmountOnExit
      sx={PANEL_ACCORDION_SX}
    >
      {/* Same order as the other areas: own fields, load carrier settings, vehicle settings last */}
      <Stack direction='column' spacing={FIELDS_SPACING} pb={FIELDS_PADDING_BOTTOM}>
        <LoadHandlingType selectedManualAreas={selectedManualAreas} />
        <Accordion
          persistId={UserPreferenceName.ACCORDION_PROPERTY_PANEL_MANUAL_LOAD_CARRIER_SETTINGS}
          titleKey='interface:properties.sections.load_carrier_settings'
          unmountOnExit
        >
          <Stack direction='column' spacing={FIELDS_SPACING}>
            <LoadType selectedAreas={selectedManualAreas} />
            <StationSpecProperties selectedManualAreas={selectedManualAreas} />
          </Stack>
        </Accordion>
        <Accordion
          persistId={UserPreferenceName.ACCORDION_PROPERTY_PANEL_MANUAL_VEHICLE_SETTINGS}
          titleKey='interface:properties.sections.vehicle_settings'
          unmountOnExit
        >
          <Stack direction='column' spacing={FIELDS_SPACING}>
            <VehicleType selectedAreas={selectedManualAreas} />
          </Stack>
        </Accordion>
      </Stack>
    </Accordion>
  );
}

export const ManualAreaParameters = memo(ManualAreaParametersComponent);
